import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Button, Card, Form, Input, Modal, notification, Space, Table, Upload } from 'antd';
import AWS from 'aws-sdk';
import LoadingAnimation from '../../componets/loader/loader';
import { DELETE, GET, POST } from '../../utils/apicalls';
import { API } from '../../config/api';




function VideoManagement() {
    const [meta, setMeta] = useState<any>({});
    const [data, setData] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [fileUrl, setFileUrl] = useState<string | null>(null);
    const navigate = useNavigate();
    interface AwsData {
        accessKeyId?: string;
        secretAccessKey?: string;
        region?: string;
        [key: string]: any;
    }
    const [awsData, setawsData] = useState<AwsData>({});
    const s3 = new AWS.S3({
        accessKeyId: awsData.accessKeyId,
        secretAccessKey: awsData.secretAccessKey,
        region: awsData.region,
    });
    const fetchawsDetails = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.AWS_KEY, {}); // This should return the above JSON
            if (response && response.accessKeyId) {
                setawsData(response); // Not response.data
            } else if (response?.data?.accessKeyId) {
                setawsData(response.data); // If using Axios-style
            } else {
                console.warn("AWS credentials not found in response", response);
            }
        } catch (error) {
            console.error("Failed to fetch AWS credentials", error);
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        if (awsData.accessKeyId && awsData.secretAccessKey && awsData.region) {
            AWS.config.update({
                accessKeyId: awsData.accessKeyId,
                secretAccessKey: awsData.secretAccessKey,
                region: awsData.region,
            });
        }
    }, [awsData]);
    useEffect(() => {
        fetchawsDetails();
    }, []);
    const S3_BUCKET = awsData?.bucketName;

    const handleFileChange = (info: any) => {
        if (info.file.status === "done") {
            const fileUrl = info.file.response?.location || info.file.response?.url;
            if (fileUrl) {
                setFileUrl(fileUrl);
                form.setFieldsValue({ videomanagementVideo: fileUrl });
            }
        } else if (info.file.status === "error") {
            notification.error({ message: "Video upload failed!" });
        }
    };

    const uploadProps = {
        name: "file",
        headers: {
            "x-amz-acl": "public-read",
        },
        onChange: handleFileChange,
        customRequest: async (options: any) => {
            const { onSuccess, onError, file } = options;
            const fileName = `videos/${Date.now()}_${file.name}`;
            const params = {
                Bucket: S3_BUCKET,
                Key: fileName,
                Body: file,
                ContentType: file.type,
                // ACL: "public-read",
            };

            s3.upload(params, (err: any, data: any) => {
                if (err) {
                    onError(err);
                    notification.error({ message: "Video upload failed!" });
                } else {
                    setFileUrl(data.Location);
                    form.setFieldsValue({ videomanagementVideo: data.Location });
                    onSuccess(data);
                    notification.success({ message: "Video uploaded successfully!" });
                }
            });
        },
    };

    const submitHandler = async (values: any) => {
        try {
            const obj = {
                videomanagementTitle: values.videomanagementTitle,
                videomanagementDescription: values.videomanagementDescription,
                videomanagementVideo: fileUrl,
            };

            setIsLoading(true);
            const postRequest: any = await POST(API.CREATE_VIDEO_MANAGEMENT, obj);

            if (postRequest.status) {
                notification.success({ message: "Video uploaded successfully!" });
                form.resetFields();
                setFileUrl(null);
                setIsModalOpen(false);
                fetchvideo();
            } else {
                notification.error({ message: "Failed to upload video" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later.",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (id: any) => {
        try {
            setIsLoading(true);
            const delete_url = `${API.DELETE_VIDEO_MANAGEMENT}${id}`;
            const data: any = await DELETE(delete_url);

            if (data.status) {
                notification.success({ message: "Video deleted successfully!" });
                fetchvideo();
            } else {
                notification.error({
                    message: "Something went wrong! Please try again later.",
                });
            }
        } catch (error) {
            console.log(error);
            notification.error({
                message: "Something went wrong! Please try again later.",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const confirmDelete = (id: any) => {
        const confirm = window.confirm("Are you sure you want to delete this video?");
        if (confirm) {
            handleDelete(id);
        }
    };

    const fetchvideo = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.LIST_VIDEO_MANAGEMENT, {});
            setData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchvideo();
    }, []);

    const columns = [
        {
            title: "Index",
            dataIndex: "index",
            render: (_: any, __: any, index: number) => index + 1,
        },
        { title: "Title", dataIndex: "videomanagementTitle" },
        { title: "Description", dataIndex: "videomanagementDescription" },
        {
            title: "Media",
            dataIndex: "videomanagementVideo",
            render: (url: string) =>
                url?.match(/\.(mp4|webm|ogg)$/i) ? (
                    <video src={url} controls style={{ width: 150, height: 100 }} />
                ) : url ? (
                    <img src={url} alt="Media" style={{ width: 150, height: 100, objectFit: "cover" }} />
                ) : (
                    <span>No media</span>
                )

        },

        {
            title: "Actions",
            key: "actions",
            render: (_: any, record: any) => (
                <Space size="middle">
                    <Button type="link" onClick={() => confirmDelete(record.id)}>
                        Delete
                    </Button>
                    <Button
                        type="link"
                        onClick={() =>
                            navigate(`/Admin/adminVideoManagement/updateVideoManagement/${record.id}`)
                        }
                    >
                        Edit
                    </Button>
                </Space>
            ),
        },
    ];

    return (
        <div>
            <div className="banner-container">
                {isLoading ? (
                    <LoadingAnimation />
                ) : (
                    <div className="banner-content">
                        <h1 className="banner-title">Video Management</h1>
                        <button className="banner-button" onClick={() => setIsModalOpen(true)}>
                            Upload New Video
                        </button>
                    </div>
                )}
            </div>

            <Card>
                <div className="table-responsive" style={{ overflowX: "auto" }}>
                    <Table
                        columns={columns}
                        dataSource={data}
                        loading={isLoading}
                        pagination={{
                            current: meta?.currentPage || 1,
                            pageSize: meta?.pageSize || 10,
                            total: meta?.totalItems || 0,
                            showSizeChanger: true,
                        }}
                        rowKey={(record: any) => record.id}
                        scroll={{ x: "max-content" }}
                    />
                </div>
            </Card>

            <Modal
                title="Upload Video"
                visible={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                width="90%"
            >
                <Form form={form} onFinish={submitHandler} layout="vertical">
                    <Form.Item
                        name="videomanagementTitle"
                        label="Video Title"
                        rules={[{ required: true, message: "Please enter a title" }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="videomanagementDescription"
                        label="Description"
                        rules={[{ required: true, message: "Please enter a description" }]}
                    >
                        <Input.TextArea />
                    </Form.Item>

                    <Form.Item
                        name="videomanagementVideo"
                        label="Upload Video or Image"
                        rules={[{ required: true, message: "Please upload a video or image" }]}
                    >
                        <Upload
                            {...uploadProps}
                            accept="video/*,image/*"
                            showUploadList={false}
                            beforeUpload={(file) => {
                                const isValid = file.type.startsWith("video/") || file.type.startsWith("image/");
                                if (!isValid) {
                                    notification.error({ message: "Only video or image files are allowed!" });
                                }
                                return isValid || Upload.LIST_IGNORE;
                            }}
                        >
                            <Button className="w-full">Upload Video / Image</Button>
                        </Upload>

                        {fileUrl && fileUrl.match(/\.(mp4|webm|ogg)$/i) && (
                            <video
                                src={fileUrl}
                                controls
                                className="w-full mt-2"
                                style={{ height: "300px", objectFit: "cover" }}
                            />
                        )}

                        {fileUrl && fileUrl.match(/\.(jpg|jpeg|png|gif|bmp|webp)$/i) && (
                            <img
                                src={fileUrl}
                                alt="Uploaded"
                                className="w-full mt-2"
                                style={{ height: "300px", objectFit: "cover" }}
                            />
                        )}
                    </Form.Item>

                    <Button type="primary" htmlType="submit" block>
                        Submit
                    </Button>
                </Form>
            </Modal>
        </div>
    );
}

export default VideoManagement;
